/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { footerSettings } from '../../services/channelData.service';
import twitterIcon from '../../assets/images/icons/twitter.svg';
import instagramIcon from '../../assets/images/icons/instagram.svg';
import pinterestIcon from '../../assets/images/icons/pinterest.svg';
import facebookIcon from '../../assets/images/icons/facebook.svg';
import googleIcon from '../../assets/images/icons/google.svg';
import youtubeIcon from '../../assets/images/icons/youtube.svg';
import tiktokIcon from '../../assets/images/icons/tiktok.svg';
import footerlogo from '../../assets/images/shilo/logo.png';


const Footer = ({ menuData, handlePageChange, copyRightText }) => {
  const [footerSettingDetails, setFooterSettingDetails] = useState();
  const location = useLocation();

  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const footerSetting = await footerSettings();
        const response = footerSetting.content[0];
        setFooterSettingDetails(response);
      } catch (error) {
        // console.error("Error fetching footer settings:", error);
      }
    };

    fetchFooterSettings();
  }, []);

  const shouldShowFooter = () => {
    if (!footerSettingDetails) return false;

    const topMenu = footerSettingDetails.left_section?.header_footer_pages || [];
    if (topMenu.includes("all")) return true;

    const currentPage = location.pathname.replace("/", "") || "Home";
    return topMenu.includes(currentPage);
  };

  const handleCookieSettingsClick = () => {
    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
    } else {
      // console.warn('OneTrust SDK not loaded yet');
    }
  };


  const socialIcons = {
    facebook: facebookIcon,
    instagram: instagramIcon,
    twitter: twitterIcon,
    pinterest: pinterestIcon,
    google: googleIcon,
    youtube:youtubeIcon,
    tiktok:tiktokIcon,
  };

  const socialMedia =
    footerSettingDetails?.right_section?.social_media || [];

  const hasSocialIcons = socialMedia.length > 0;

  const subscribeEnabled =
    footerSettingDetails?.right_section?.subscribe_status === true;

  return (
    footerSettingDetails?.enable_footer_section === 1 && shouldShowFooter() && (
      // <div className="footer-main-container" style={{ backgroundColor: footerSettingDetails?.background_color }}>
      //     <div className="footer-links">
      //       <div className='footer-left-section'>
      //         {footerSettingDetails?.left_section?.visible_menu_bar === 1 && (
      //           menuData.map((item) => (
      //             <Link to={`/${encodeURIComponent(item.title)}`} key={item.id} onClick={() => handlePageChange(item.id)}>{item.title}</Link>
      //           ))
      //         )}

      //         {footerSettingDetails?.left_section?.menu_names_url?.map((menu, index) => (
      //           <Link
      //             key={index}
      //             to={menu.menu_url}
      //             target="_blank"
      //             rel="noopener noreferrer"
      //           >
      //           {menu.menu_name}
      //           </Link>
      //         ))}

      //         <button id="ot-sdk-btn" className="ot-sdk-show-settings" onClick={handleCookieSettingsClick}>Manage Cookie Settings</button>
      //       </div>

      //       <div className='footer-right-section'>
      //         <h3 className='footer_right_side_header'>{footerSettingDetails?.right_section.header_name}</h3>
      //         <div className="footer-images">
      //           {footerSettingDetails?.right_section?.images?.map((img) => (
      //             <Link
      //               key={img.id}
      //               to={img.target_url}
      //               target="_blank"
      //               rel="noopener noreferrer"
      //             >
      //               <img
      //                 src={img.image_url}
      //                 alt={footerSettingDetails?.right_section?.header_name || "footer image"}
      //                 className="footer-image"
      //               />
      //             </Link>
      //           ))}
      //         </div>
      //       </div>
      //     </div>
      //       <div className="copy-right-text text-white text-center">{copyRightText}</div>
      // </div>

      //  <footer className="footer">
      //       <div className="footer-container">
      //         {/* Top Section */}
      //         <div className="footer-top">
      //           <div className="footer-logo">
      //             <a href="#">
      //               <img src={footerlogo} alt="Twitter" />
      //             </a>

      //           </div>

      //           <div className="footer-right">
      //             <nav className="footer-links">
      //               <a href="/">Home</a>
      //               <a href="/signup">Sign Up</a>
      //               <a href="/cookies">Manage Cookie Settings</a>

      //             </nav>

      //             <div className="subscribe-box">
      //               <input type="email" placeholder="Enter Email" />
      //               <button>Subscribe Now</button>
      //             </div>
      //           </div>
      //         </div>

      //         {/* Bottom Section */}
      //         <div className="footer-bottom">
      //           <div className="social-icons">
      //             <a href="#">
      //               <img src={twitterIcon} alt="Twitter" />
      //             </a>

      //             <a href="#">
      //               <img src={instagramIcon} alt="Instagram" />
      //             </a>

      //             <a href="#">
      //               <img src={pinterestIcon} alt="Pinterest" />
      //             </a>

      //             <a href="#">
      //               <img src={facebookIcon} alt="Facebook" />
      //             </a>

      //             <a href="#">
      //               <img src={googleIcon} alt="Google" />
      //             </a>
      //           </div>

      //           <p>© Shilo. All Rights Reserved.</p>
      //         </div>
      //       </div>
      //     </footer>

      <footer
        className="footer"
        style={{ backgroundColor: footerSettingDetails?.background_color }}
      >
        <div className="footer-container">

          {/* Top Section */}
          <div className="footer-top">

            <div className="footer-logo">
              {footerSettingDetails?.right_section?.images?.[0]?.image_url && (
                <a
                  href={
                    footerSettingDetails?.right_section?.images?.[0]?.target_url ||
                    "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={footerSettingDetails?.right_section?.images?.[0]?.image_url}
                    alt="Footer Logo"
                  />
                </a>
              )}
            </div>

            <div className="footer-right">

              <nav className="footer-links">

                {footerSettingDetails?.left_section?.visible_menu_bar === 1 &&
                  menuData.map((item) => (
                    <Link
                      key={item.id}
                      to={`/${encodeURIComponent(item.title)}`}
                      onClick={() => handlePageChange(item.id)}
                    >
                      {item.title}
                    </Link>
                  ))}

                {footerSettingDetails?.left_section?.menu_names_url?.map(
                  (menu, index) => (
                    <a
                      key={index}
                      href={menu.menu_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {menu.menu_name}
                    </a>
                  )
                )}

                {/* <button
                  id="ot-sdk-btn"
                  className="ot-sdk-show-settings"
                  onClick={handleCookieSettingsClick}
                >
                  Manage Cookie Settings
                </button> */}

              </nav>
              <div className="contact-email">
                <a href="mailto:info@shilo.tv">
                  info@shilo.tv
                </a>
              </div>


            </div>
          </div>

          {/* Bottom Section */}
          <div className={`footer-bottom ${!hasSocialIcons ? "no-social-icons" : ""}`}>


            {hasSocialIcons && (
              <div className="social-icons">
                {socialMedia.map((social, index) => {
                  const icon = socialIcons[social.platform?.toLowerCase()];

                  if (!icon) return null;

                  return (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon} alt={social.platform} />
                    </a>
                  );
                })}
              </div>
            )}

            <div className="footer-copy-right ">

              <p className={!hasSocialIcons ? "copyright-center" : ""}>
                {copyRightText}
              </p>

            </div>
            {subscribeEnabled && (
              <div className="subscribe-box">
                <input type="email" placeholder="Enter Email" />
                <button>Join the Waitlist</button>
              </div>
            )}

          </div>

        </div>
      </footer>
    )
  );
};

Footer.propTypes = {
  menuData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
    })
  ).isRequired,
  handlePageChange: PropTypes.func.isRequired,
  copyRightText: PropTypes.string.isRequired,
};

export default Footer;